import Joi from '@hapi/joi'

export const TagGenerationSchema = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    routeID: Joi.string().allow('').optional().label("Route").messages({
        "any.invalid": `Select Route`,
        "any.required": `Route required`
    }),
    employeeTypeID: Joi.string().allow('').invalid(0).optional().label("Route").messages({
        "any.invalid": `Select Employee Type`,
        "any.required": `Employee Type required`
    }),
    haverstingJobTypeID: Joi.string().allow('').invalid(0).optional().label("Route").messages({
        "any.invalid": `Select Haversting Job Type`,
        "any.required": `Haversting Job Type required`
    }),
    noOfCodes: Joi.number().required().invalid(0).min(1).max(150).label("No. of Codes").messages({
        "any.invalid": `Select Number of codes`,
        "any.required": `Number of codes required`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
}

